import { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";
import { authActions } from "../../store/auth";
import { templateAction } from "../../store/template-store";
import SingleTemplate from "./SingleTemplate";

const TemplateList = (props) => {
  const [templates, setTemplates] = useState([]);

  const dispatch = useDispatch();

  const { sendRequest } = useHttp();
  const { sendRequest: makeFavTempRequest } = useHttp();

  const is_loaded = useSelector((state) => state.template.is_loaded);
  const token = useSelector((state) => state.auth.token);
  const defaultTemplate = useSelector((state) => state.template.template_data);
  const ez_sid = useSelector((state) => state.ezleadzStore.subdomain_id);
  const myAccess = useSelector((state) => state.auth.access);

  // console.log(props.showFav);
  useEffect(() => {
    const responseData = (response) => {
      // console.log(response);

      if (response.body) {
        // console.log(response.body);
        // setTemplates("Hello");
        if(ez_sid){
          // console.log("ez_sid");
          const display_template_by_order = response.body.filter(template => template.display_order === 1);
          const display_template_all = response.body.filter(template => template.display_order !== 1);
          // console.log(display_template_by_order);
          const all_available_templates = [...display_template_by_order, ...display_template_all];

          setTemplates(all_available_templates);

          dispatch(templateAction.setTemplateData({ template_data: all_available_templates }));
        }else{
          // console.log("else_sid");
          if(myAccess.includes("5") || myAccess.includes("8B") || myAccess.includes("3A") ||  myAccess.includes("9A")){
            const display_template_by_order = response.body.filter(template => template.display_order === 311 && template.status === 1);
            const display_template_all = response.body.filter(template => template.display_order !== 311);
            // console.log(display_template_by_order);
            const all_available_templates = [...display_template_by_order, ...display_template_all];
  
            setTemplates(all_available_templates);
            dispatch(templateAction.setTemplateData({ template_data: all_available_templates }));
          }else if(myAccess.includes("2A") || myAccess.includes("8A") || myAccess.includes("1a")){
            const display_template_all = response.body.filter(template => template.display_order <= 30);
            setTemplates(display_template_all);
            dispatch(templateAction.setTemplateData({ template_data: display_template_all }));
          }
          else if(myAccess.includes("1A")){
            const display_template_by_order = response.body.filter(template => template.display_order <= 10);
            setTemplates(display_template_by_order);
            // console.log(display_template_by_order);
            dispatch(templateAction.setTemplateData({ template_data: display_template_by_order }));
          }

        }
        // console.log(response.body);
      }
      dispatch(authActions.setLoaderStatus({ status: false }));
    };
    if (!is_loaded) {
      dispatch(authActions.setLoaderStatus({ status: true }));
      sendRequest(
        {
          url: endPoints.fetchTemplates,
          method: "GET",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
        responseData
      );
    } 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, is_loaded, sendRequest, setTemplates, defaultTemplate,token,ez_sid]);

  useEffect(() => {
    if (
      is_loaded &&
      defaultTemplate &&
      templates.length === 0 &&
      props.showFav === 0
    ) {
      setTemplates(defaultTemplate);
    }
  }, [is_loaded, defaultTemplate, templates, props.showFav]);

  const handleTemplateId = (id) => {
    props.templateId(id);
  };

  const handleMakeFav = (template_id, is_fav) => {
    // console.log(template_id, is_fav, "akash");
    const isFav = is_fav ? 0 : 1;

    const dummyTemp = defaultTemplate.map((template) => {
      var temp = { ...template };

      if (template.id === template_id) {
        temp.fav = isFav;
      }

      return temp;
    });

    makeFavTempRequest({
      url: isFav ? endPoints.makeFav : endPoints.removeFav,
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: {
        template_id,
        isFav,
      },
    });
    setTemplates(dummyTemp);
    dispatch(templateAction.setTemplateData({ template_data: dummyTemp }));

    if (props.showFav === 1) {
      const favTemp = dummyTemp.filter((template) => template.fav > 0);
      setTemplates(favTemp);
    }
  };

  useEffect(() => {
    if (props.showFav === 1) {
      const favTemp = templates.filter((template) => template.fav > 0);
      setTemplates(favTemp);
    } else {
      setTemplates([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.showFav]);

  return (
    <>
      {templates.length > 0 &&
        templates.map(
          (template) =>
            template.status === 1 && (
              <SingleTemplate
                key={template.id}
                id={template.id}
                main_temp_id={template.main_id}
                templateId={handleTemplateId}
                name={template.name}
                preview_url={template.preview_url}
                thumbnail_url={template.thumbnail_url}
                is_fav={template.fav ? 1 : 0}
                selectedTemp={props.selectedTemp}
                makeIsfav={(e) =>
                  handleMakeFav(template.id, template.fav ? 1 : 0)
                }
              />
            )
        )}
      {templates.length <= 0 && <p>No Templates available</p>}
    </>
  );
};

export default TemplateList;
